import { trim } from 'jquery';
import { SrcExamResultService } from './src-exam-result.service';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from 'src/app/shared/utility/utility';
import { LoadingService } from 'src/app/layout/loading/loading.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DialogModalService } from 'src/app/shared/dialog-modal/dialog-modal.service';
import { isNumber } from 'ngx-bootstrap/chronos/utils/type-checks';
@Component({
  selector: 'app-src-exam-result',
  templateUrl: './src-exam-result.component.html',
  styleUrls: ['./src-exam-result.component.scss']
})
export class SrcExamResultComponent implements OnInit {
  lstInspecResul = [];
  objRecept = null;
  objUser = null;
  objData: any;
  rgxOperator = /[=,<>]/gi;

  constructor(
    public util: Utility,
    public trans: TranslateService,
    private service: SrcExamResultService,
    private loading: LoadingService,
    private router: Router,
    private routeActived: ActivatedRoute,
    private dialogModalService: DialogModalService
  ) { }

  ngOnInit(): void {
    this.objRecept = {
      HTOrgCode: this.routeActived.snapshot.queryParams.htorgcode,
      ConsulDay: this.routeActived.snapshot.queryParams.consulday,
      ConsulNum: this.routeActived.snapshot.queryParams.consulnum
    };

    const srtUser = localStorage.getItem('ExamineauthorizationData');
    if (srtUser) {
      this.objUser = JSON.parse(srtUser);
      this.getInspecResult();
    } else {
      this.router.navigate(['login'], {
        queryParams: {
          htorgcode: this.objRecept.HTOrgCode, consulday: this.objRecept.ConsulDay,
          consulnum: this.objRecept.ConsulNum
        }
      });
    }
    this.util.resetZoomBrowser();
  }

  getInspecResult() {
    if (this.objRecept && this.objUser) {
      const objParam = {
        ConsulDay: this.objRecept.ConsulDay,
        ConsulNum: this.objRecept.ConsulNum,
        UserID: this.objUser.UserID,
        HTOrgCode: this.objRecept.HTOrgCode
      };
      this.loading.setDisplay(true);
      this.service.getInspecResult(objParam).subscribe(res => {
        this.loading.setDisplay(false);
        if (res) {
          res.ReportNote = res.ReportNote?.replace('\n', '<br>');
          this.objData = res;
        }
        else {
          /* 20231005 modify #19285 start */
          // this.dialogModalService.openErrorModal(this.trans.instant('MESS_EXCEPTION_OCCURRED')).subscribe(() => {
          this.dialogModalService.openErrorModal(this.trans.instant('MESS_INFORMATION_NOT_EXIST')).subscribe(() => {
          /* 20231005 modify #19285 end */
            this.router.navigate(['toppage']);
          });
        }
      },
        error => {
          this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED').subscribe(() => {
            this.router.navigate(['toppage']);
          });
        });
    }
  }

  downLoad() {
    const objParam = {
      ConsulDay: this.objRecept.ConsulDay,
      ConsulNum: this.objRecept.ConsulNum,
      HTOrgCode: this.objRecept.HTOrgCode
    };
    const fileName = this.trans.instant('STR_EXAM_RESULT_REPORT');
    this.loading.setDisplay(true);
    this.service.download(objParam).subscribe(res => {
      this.loading.setDisplay(false);
      if (res) {
        const rs = this.base64ToArrayBuffer(res);
        const blob = new Blob([rs], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.download = fileName + '_' + objParam.ConsulDay + '_' + objParam.ConsulNum + '.pdf';
        document.body.appendChild(a);
        a.click();
      } else {
        this.dialogModalService.openErrorModal(this.trans.instant('MESS_EXCEPTION_OCCURRED'));
      }
    },
      error => { this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED'); }
    )
      ;
  }

  base64ToArrayBuffer(base64) {
    const binaryStr = window.atob(base64);
    const len = binaryStr.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryStr.charCodeAt(i);
    }
    return bytes.buffer;
  }

  getDayName(value) {
    if (value == null || value.length < 8) {
      return '';
    }
    const y = value.substring(0, 4);
    let m: string = value.substring(4, 6);
    let d: string = value.substring(6);
    const dateOfWeek = new Date(y, +m - 1, +d).getDay() + 1;
    const lang = localStorage.getItem('language');
    if (m.startsWith('0')) {
      m = m.replace('0', '');
    }
    if (d.startsWith('0')) {
      d = d.replace('0', '');
    }
    let day = y + '年' + m + '月' + d + '日';
    if (lang === 'vi') {
      day = d + '/' + m + '/' + y;
    }
    else if (lang === 'en') {
      day = y + '/' + m + '/' + d;
    }
    const strNameDay = this.util.getNameDay(dateOfWeek);
    return day + ' ' + (strNameDay ? '(' + this.trans.instant(strNameDay) + ')' : '');
  }

  checkHLbyJugdiv(jugdiv) {
    switch (jugdiv) {
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
        return 'H';
      case '-1':
      case '-2':
      case '-3':
      case '-4':
      case '-5':
        return 'L';
      default:
        return '';
    }
  }

  openExplanation() {
    this.service.getResultInfo().subscribe(res => {
      const messsage = this.trans.instant('STR_RESULT_GUIDE_DIALOG').replace('{0}', res);
      this.dialogModalService.openInfoModal(messsage);
    },
      error => {
        this.dialogModalService.openErrorModal('MESS_EXCEPTION_OCCURRED');
      });
  }

  backToppage() {
    this.router.navigate(['toppage']);
  }

  roundValue(strValue, fraCalDiv, decimalStr, ResultType) {
    if (this.util.isNullOrBlank(strValue)) {
      return '';
    }
    if ((ResultType === '1' || ResultType === '2') && strValue?.toString() === 'C01'){
      return this.trans.instant('STR_UNABLE_TO_INSPECT');
    }
    const strRaw = strValue.replace(this.rgxOperator, '');
    if (this.util.isNullOrBlank(strRaw)) {
      return strValue;
    }
    let value = '';
    if (this.util.isNullOrBlank(decimalStr)) {
      return strValue?.toString() === 'C01'?  this.trans.instant('STR_UNABLE_TO_INSPECT') :strValue
    }

    const decimalVale = +decimalStr;
    if (decimalVale) {
      switch (fraCalDiv) {
        case '1':
          const va1 = Math.floor(Math.pow(10, decimalVale) * +strRaw) / Math.pow(10, decimalVale);
          value = va1.toFixed(decimalVale);
          break;
        case '2':
          const va2 = Math.floor(Math.pow(10, decimalVale) * +strRaw) / Math.pow(10, decimalVale);
          value = va2.toFixed(decimalVale);
          break;
        case '3':
          const va3 = Math.floor(Math.pow(10, decimalVale) * +strRaw) / Math.pow(10, decimalVale);
          value = va3.toFixed(decimalVale);
          break;
      }
      return this.getOperator(strValue, value, strRaw);
    }
    else if (decimalVale === 0) {
      const valueNum = +strRaw;
      if (valueNum) {
        value = valueNum.toFixed(decimalVale);
        return this.getOperator(strValue, value, strRaw);
      }
      return strValue;
    }
    else {
      return strValue;
    }
  }

  getOperator(pValue: string, value: string, strRaw: string) {
    let Operator = '';
    let i = 0;
    const opera = [];
    for (const c of pValue) {
      if (c.match(this.rgxOperator)) {
        const param = {
          idx: i,
          Operator: c,
        };
        opera.push(param);
        Operator += c;
      }
      i++;
    }
    if (pValue.indexOf(Operator) !== 0) {
      return value;
    }
    if (opera.length > 0) {
      if (opera[opera.length - 1].idx - opera[0].idx > 1) {
        return value;
      }
    }
    if (Operator === '<' || Operator === '>' || Operator === '>=' || Operator === '<=') {
      return pValue.replace(strRaw, value);
    }
    return value;
  }
}
